// src/api/wholesaleApi.ts
import { http } from "./http";

export type WholesaleRequestStatus = "pending" | "approved" | "rejected";

export interface WholesaleRequest {
  id: number;
  user_id: number;
  business_name: string;
  contact_name: string | null;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  website: string | null;
  business_type: string | null;
  address: string | null;
  heard_about: string | null;
  // legacy (older applications only)
  business_number?: string | null;
  message?: string | null;
  status: WholesaleRequestStatus;
  reviewed_by: number | null;
  reviewed_at: string | null;
  review_notes: string | null;
  created_at: string;
  user_email: string;
  user_name: string;
  user_is_wholesale: boolean;
  user_tier_id: number | null;
}

export interface WholesaleTier {
  id: number;
  name: string;
  description: string | null;
  sort_order: number;
  is_default: boolean;
  discount_pct?: number | string;
  customer_count?: number;
}

export interface TierInput {
  name?: string;
  description?: string | null;
  discount_pct?: number;
  sort_order?: number;
}

export const fetchWholesaleRequests = async (
  status?: WholesaleRequestStatus
): Promise<WholesaleRequest[]> => {
  const res = await http.get("/wholesale/requests", {
    params: status ? { status } : {},
  });
  return res.data;
};

export const approveWholesaleRequest = async (id: number, tier_id?: number) => {
  const res = await http.post(`/wholesale/requests/${id}/approve`, { tier_id });
  return res.data;
};

export const rejectWholesaleRequest = async (id: number, review_notes?: string) => {
  const res = await http.post(`/wholesale/requests/${id}/reject`, { review_notes });
  return res.data;
};

export const fetchWholesaleTiers = async (): Promise<WholesaleTier[]> => {
  const res = await http.get("/wholesale/tiers");
  return res.data;
};

export const createWholesaleTier = async (input: TierInput): Promise<WholesaleTier> => {
  const res = await http.post("/wholesale/tiers", input);
  return res.data;
};

export const updateWholesaleTier = async (
  id: number,
  input: TierInput
): Promise<WholesaleTier> => {
  const res = await http.put(`/wholesale/tiers/${id}`, input);
  return res.data;
};

export const deleteWholesaleTier = async (id: number) => {
  const res = await http.delete(`/wholesale/tiers/${id}`);
  return res.data;
};

// Assign an approved wholesale customer to a tier (null clears to default).
export const setCustomerTier = async (userId: number, tier_id: number | null) => {
  const res = await http.post(`/wholesale/customers/${userId}/tier`, { tier_id });
  return res.data;
};
